import Axios from "axios";
import {
    SET_DOCUMENTS_FILE_LIST,
    UNSET_DOCUMENTS_FILE_LIST,
} from "@/store/mutation-types";

import { 
    saveDocumentsFile, 
    getDocumentsFileList,
    downloadFile,
    deleteDocumentsFile,
} from "@/store/api";

const state = {
    getDocumentsFileList: [],
};

const getters = {
    getDocumentsFileList(state) {
        return state.getDocumentsFileList;
    },
};

const mutations = {
    [SET_DOCUMENTS_FILE_LIST](state, data) {
        state.getDocumentsFileList = data;
    },
    [UNSET_DOCUMENTS_FILE_LIST](state) {
        state.getDocumentsFileList = [];
    },
};

const actions = {
    saveDocumentsFile({ commit }, { formData, onProgress, signal }) {
        return new Promise((resolve, reject) => {
            // Build axios config
            const axiosConfig = {
                headers: {
                    "Content-Type": "multipart/form-data"
                },
                // 🔥 Track progress for each chunk uploaded
                onUploadProgress: (progressEvent) => {
                    if (progressEvent.lengthComputable) {
                        const percentComplete = Math.round(
                            (progressEvent.loaded * 100) / progressEvent.total
                        );
                        
                        // Call callback with accurate progress
                        if (typeof onProgress === 'function') {
                            onProgress(percentComplete);
                        }
                    }
                },
            };

            // Only add signal if it's provided (for abort functionality)
            if (signal) {
                axiosConfig.signal = signal;
            }

            Axios.post(saveDocumentsFile, formData, axiosConfig)
                .then((response) => {
                    // Set to 100% when complete
                    if (typeof onProgress === 'function') {
                        onProgress(100);
                    }
                    resolve(response);
                })
                .catch((error) => {
                    // Handle abort errors gracefully
                    if (error.name === 'AbortError') {
                        console.log('Upload aborted by user');
                        reject(error);
                    } else if (error.code === 'ECONNABORTED') {
                        console.error('Upload timeout or aborted:', error);
                        reject(error);
                    } else {
                        console.error('Upload error:', error);
                        reject(error);
                    }
                });
        });
    },

    getDocumentsFileList({ commit }, data) {
        return new Promise((resolve, reject) => {
            commit("SET_LOADING", { color: "primary" });
            
            Axios.get(getDocumentsFileList, { params: data })
                .then((response) => {
                    commit('SET_DOCUMENTS_FILE_LIST', response.data.data);
                    resolve(response);
                })
                .catch((error) => {
                    commit('UNSET_DOCUMENTS_FILE_LIST');
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING");
                });
        });
    },

    downloadFile({ commit }, data) {
        return new Promise((resolve, reject) => {
            commit("SET_LOADING", { color: "primary" });
            
            Axios.get(downloadFile + `/${data}/download`, {
                responseType: 'blob'
            })
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                console.error('Download error:', error);
                reject(error);
            })
            .finally(() => {
                commit("UNSET_LOADING");
            });
        });
    },

    deleteFile({ commit }, data) {
        return new Promise((resolve, reject) => {
            commit("SET_LOADING", { color: "primary" });
            
            Axios.delete(deleteDocumentsFile + `/${data}`)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    console.error('Delete error:', error);
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING");
                });
        });
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};